/**
 * Email API — axios wrappers (auth via shared api instance interceptors).
 */
import api from '../api';

/** @param {import('axios').AxiosError} error */
export function getEmailApiErrorMessage(error) {
  const d = error.response?.data;
  if (!d) return error.message || 'Request failed';
  if (typeof d === 'string') return d;
  if (d.detail) {
    if (Array.isArray(d.detail)) {
      return d.detail.map((x) => (typeof x === 'string' ? x : x?.msg || String(x))).join(' ');
    }
    return String(d.detail);
  }
  if (d.error && typeof d.error === 'string') return d.error;
  if (d.message && typeof d.message === 'string') return d.message;
  if (d.non_field_errors?.length) return String(d.non_field_errors[0]);
  const firstKey = Object.keys(d).find((k) => Array.isArray(d[k]) && d[k].length);
  if (firstKey) return String(d[firstKey][0]);
  return error.message || 'Request failed';
}

export async function listEmails(params) {
  const { data } = await api.get('/api/emails/', { params });
  return data;
}

export async function createEmail(payload) {
  const { data } = await api.post('/api/emails/', payload);
  return data;
}

export async function getEmail(id) {
  const { data } = await api.get(`/api/emails/${id}/`);
  return data;
}

export async function updateEmail(id, payload) {
  const { data } = await api.patch(`/api/emails/${id}/`, payload);
  return data;
}

export async function deleteEmail(id) {
  await api.delete(`/api/emails/${id}/`);
}

export async function sendEmail(id) {
  const { data } = await api.post(`/api/emails/${id}/send/`, {});
  return data;
}

export async function scheduleEmail(id, scheduledAtIso) {
  const { data } = await api.post(`/api/emails/${id}/schedule/`, { scheduled_at: scheduledAtIso });
  return data;
}

export async function uploadEmailAttachment(emailId, formData) {
  const { data } = await api.post(`/api/emails/${emailId}/attachments/`, formData);
  return data;
}

export async function listEmailTemplates(params) {
  const { data } = await api.get('/api/email-templates/', { params });
  return data;
}

export async function createEmailTemplate(payload) {
  const { data } = await api.post('/api/email-templates/', payload);
  return data;
}

export async function updateEmailTemplate(id, payload) {
  const { data } = await api.patch(`/api/email-templates/${id}/`, payload);
  return data;
}

export async function deleteEmailTemplate(id) {
  await api.delete(`/api/email-templates/${id}/`);
}

export async function listMergeTags() {
  const { data } = await api.get('/api/email-templates/merge-tags/');
  return data;
}

export async function previewEmailRender(payload) {
  const { data } = await api.post('/api/emails/preview-render/', payload);
  return data;
}
